import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import Link from 'redux-first-router-link';

import logo from '../images/logo_nav.svg';
import hamburger from '../images/nav_humburger.svg';
import close from '../images/nav_close.svg';

import { auth } from '../lib/auth';

import SelectOrganization from './Components/SelectOrganization';

class HeaderView extends Component {
  constructor(props) {
    super(props);

    this.routeToOrg = this.routeToOrg.bind(this);
  }

  routeToOrg(orgId) {
    const {
      routeToOrg,
      type,
      payload = {},
      query = {},
    } = this.props;
    routeToOrg({ type, payload: { ...payload, orgId }, query: { ...query } });
  }

  focusSearch() {
    this.searchInput.focus();
  }

  logout() {
    const { routeToLogin } = this.props;
    auth.logout().then(() => {
      routeToLogin();
    });
  }

  render() {
    const { orgName = '', menuClosed = false, payload = {} } = this.props;
    return (
      <span
        style={{
          flex: '1 0 auto',
          display: 'inherit',
          height: '100%',
        }}
      >
        <div
          style={{
            width: '261px',
          }}
          className='menu-item logo'
        >
          <span
            className='align-middle image'
            role='button'
            tabIndex={-1}
            style={{ cursor: 'pointer' }}
          >
            <img
              style={{ height: '100%', padding: '10px 10px' }}
              src={logo}
              alt='Logo'
            />
          </span>
          <span
            style={{
              position: 'absolute',
              top: '-6px',
              right: '10px',
              height: '22px',
              width: '22px',
              cursor: 'pointer',
              color: '#FFF',
              fontSize: '36px',
              fontWeight: '300',
            }}
            className='button'
            role='button'
            tabIndex={-1}
            onClick={() => { this.props.toggleMenu(); }}
          >
            {!menuClosed &&
              <img
                src={hamburger}
                alt='Open Menu'
                style={{ width: '100%', height: '100%' }}
              />
            }
            {menuClosed &&
              <img
                src={close}
                alt='Close Menu'
                style={{ width: '100%', height: '100%' }}
              />
            }
          </span>
        </div>
        <div
          style={{
            width: '20%',
            minWidth: '250px',
            maxWidth: '300px',
            padding: '0px 24px',
          }}
          className='menu-item orgs'
        >
          <span className='menu-item-span'>
            <SelectOrganization
              orgName={orgName}
              orgId={payload.orgId}
              routeToOrg={this.routeToOrg}
            />
          </span>
        </div>
        <div
          style={{
            width: 'auto',
            float: 'right',
            padding: '0px 24px',
          }}
          className='menu-item user'
        >
          <span className='menu-item-span'>
            <span style={{ verticalAlign: 'middle' }}>
              <img
                style={{
                  fontSize: '23px',
                  position: 'relative',
                  border: '1px solid #FFF',
                  borderRadius: '24px',
                  width: '24px',
                  height: '24px',
                  overflow: 'hidden',
                  top: '-5px',
                }}
                alt={auth.payload.nickname}
                src={auth.payload.picture}
              />
            </span>
            <DropdownButton
              bsStyle='primary'
              title={`${this.props.user.first_name} ${this.props.user.last_name}`}
              id='user-dropdown'
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                padding: '8px 0px',
                marginLeft: '10px',
                top: '-4px',
              }}
            >
              <Link
                to={{
                  type: 'PAGE',
                  payload: {
                    orgId: payload.orgId,
                    toplevel: 'user',
                    secondlevel: 'myaccount',
                  },
                }}
                onClick={() => { document.dispatchEvent(new MouseEvent('click')); }}
              >
                My Account
              </Link>
              <Link
                to={{
                  type: 'PAGE',
                  payload: {
                    orgId: payload.orgId,
                    toplevel: 'user',
                    secondlevel: 'myaccount',
                  },
                }}
                onClick={() => { document.dispatchEvent(new MouseEvent('click')); }}
              >
                My Alert Settings
              </Link>
              <MenuItem
                eventKey={4}
                onClick={this.logout.bind(this)}
              >
                Logout
              </MenuItem>
            </DropdownButton>
          </span>
        </div>
      </span>
    );
  }
}

HeaderView.propTypes = {
  type: PropTypes.string.isRequired,
  payload: PropTypes.shape({}),
  query: PropTypes.shape({}),
  orgName: PropTypes.string,
  toggleMenu: PropTypes.func.isRequired,
  routeToLogin: PropTypes.func.isRequired,
  routeToOrg: PropTypes.func.isRequired,
  menuClosed: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
  }),
};

HeaderView.defaultProps = {
  payload: {},
  query: {},
  orgName: 'Unknown',
  user: {
    first_name: '',
    last_name: '',
  },
};

export default HeaderView;



// WEBPACK FOOTER //
// ./src/views/HeaderView.js